import { downloadFile } from '../../api/request';

export function getUserDataExport() {
    const path = `/v5/users/dataExport`;
    const requestOptions = { method: 'POST' };
    return downloadFile(path, requestOptions);
}

export function getMediaExport() {
    const path = `/v5/users/dataExport/media`;
    const requestOptions = { method: 'POST' };
    return downloadFile(path, requestOptions);
}
